import { useState, useEffect } from "react";
import { Form, Spin, Tabs, Row, Col, Input, Button, Select, DatePicker } from "antd";

import dayjs from 'dayjs';

import { NumericFormat, PatternFormat } from "react-number-format";

import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { apiPrimarias } from "../../../services/api";
import { disabledDate, isStateValid, pushToBase, resetColor } from "../../../utils/utilsFunctions";

import type { IAutorizacaoEfpc, ICtrlDoc, IDocumento, IEfpc, IFundamentacaoLegal, IPessoaJuridica, ISelectList } from "../../../components/Interfaces";

import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail } from "../../../messages/messages";
import type { IErroApi } from "../../../services/api";

import { useLocation, useParams } from "react-router";
import CadInfoBotoes from "../../../components/CadInfoBotoes";
import { carregaListaDocumento, carregaListaFundamentacaoLegal } from "../../PessoaJuridica/services";
import { maskNuMatricula } from "../../../utils/maskFunctions";
import FormModalDocumento from "../../../components/FormModalDocumento";

const Cadastrar = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { tipo } = useParams();

  const [form] = Form.useForm();
  const [efpcRetPosCadastro, setEfpcRetPosCadastro] = useState<IEfpc>();

  const [operacaoAutorizarEfpc, setOperacaoAutorizarEfpc] = useState<IAutorizacaoEfpc>();
  const [pessoaJuridicaRequerente, setPessoaJuridicaRequerente] = useState<IPessoaJuridica>();
  const [pessoaJuridicaEfpc, setPessoaJuridicaEfpc] = useState<IPessoaJuridica>();

  const [efpcDocumento, setEfpcDocumento] = useState<IDocumento[]>([]);
  const [efpcDocumentoOutros, setEfpcDocumentoOutros] = useState<IDocumento[]>([]);
  const [efpcDocumentoAnalise, setEfpcDocumentoAnalise] = useState<IDocumento[]>([]);

  const [ctrlDocsEfpcDocumento, setCtrlDocsEfpcDocumento] = useState<ICtrlDoc[]>([]);
  const [ctrlDocsEfpcDocumentoOutros, setCtrlDocsEfpcDocumentoOutros] = useState<ICtrlDoc[]>([]);
  const [ctrlDocsEfpcDocumentoAnalise, setCtrlDocsEfpcDocumentoAnalise] = useState<ICtrlDoc[]>([]);

  const [manter, _setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()

  const [listFundamentacaoLegal, setListFundamentacaoLegal] = useState<ISelectList[]>([]);
  const [fundamentacaoLegal, setFundamentacaoLegal] = useState(0);
  const [listDocumentosEstatuto, setListDocumentosEstatuto] = useState<ISelectList[]>([]);
  const [listDocumentosOutrosEfpc, setListDocumentosOutrosEfpc] = useState<ISelectList[]>([]);
  const [listDocumentosAnalise, setListDocumentosAnalise] = useState<ISelectList[]>([]);

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  const [mostrarDetalhesPessoaJuridica, setMostrarDetalhesPessoaJuridica] = useState(false)
  const [sigla, setSigla] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0)

    setLoading(true);
    //console.log(state);
    const carregaDadosIniciais = async () => {
      carregaListaFundamentacaoLegalOpcoes();
      carregaListaDocumentosEstatutoOpcoes();
      carregaListaDocumentosOutrosEfpcOpcoes();
      carregaListaDocumentosAnaliseOpcoes();
    }
    carregaDadosIniciais();
    setLoading(false);

    if (isStateValid(state)) {
      if (!tipo) {
        validarOperacaoAutorizarEfpc(state.data);
        validarPessoaJuridicaRequerente(state.dataPessoaJuridicaRequerente);
        validarPessoaJuridicaEfpc(state.dataPessoaJuridicaEfpc);
      } else {
        errorMessage("Não foi possível identificar a operação de autorização da Entidade.");
        pushToBase(navigate);
      }
    }

  }, []);

  useEffect(() => {
    if (efpcRetPosCadastro) pushToManter(efpcRetPosCadastro);
  }, [efpcRetPosCadastro]);

  useEffect(() => {
    if (operacaoAutorizarEfpc) {
      form.setFieldsValue({
        operacaoCnpjRequerente: operacaoAutorizarEfpc.numeroPessoaJuridicaRequerente,
        operacaoDtPosicao: operacaoAutorizarEfpc.dataPosicao ? dayjs(operacaoAutorizarEfpc.dataPosicao) : undefined,
        operacaoNumero: operacaoAutorizarEfpc.numero,
        operacaoJustificativa: operacaoAutorizarEfpc.justificativa,
      });
    }
    if (pessoaJuridicaRequerente) {
      form.setFieldsValue({
        operacaoRazaoSocial: pessoaJuridicaRequerente.razaoSocial
      });
    }
    if (pessoaJuridicaEfpc) {
      form.setFieldsValue({
        efpcNumeroEfpcCnpj: pessoaJuridicaEfpc.tipoIdentificador === 1 ? pessoaJuridicaEfpc.numero : undefined,
        efpcNumeroEfpcProcesso: pessoaJuridicaEfpc.tipoIdentificador === 3 ? pessoaJuridicaEfpc.numero : undefined,
        efpcNumeroProcesso: pessoaJuridicaEfpc.numeroProcesso,
        efpcRazaoSocial: pessoaJuridicaEfpc.razaoSocial
      });
    }
  }, [operacaoAutorizarEfpc, pessoaJuridicaRequerente, pessoaJuridicaEfpc]);

  function validarOperacaoAutorizarEfpc(opsEfpc: IAutorizacaoEfpc) {
    if (!opsEfpc || opsEfpc.numero === "") {
      errorMessage("A Operação de Autorização de Entidade não foi identificada.");
      pushToBase(navigate);
    } else {
      setOperacaoAutorizarEfpc(opsEfpc);
    }
  }

  function validarPessoaJuridicaRequerente(pjReq: any) {
    if (!pjReq || pjReq.length === 0) {
      errorMessage("Requerente não identificado");
      pushToBase(navigate);
    } else {
      setPessoaJuridicaRequerente(pjReq);
    }
  }

  function validarPessoaJuridicaEfpc(pjReq: any) {
    if (!pjReq || pjReq.length === 0) {
      errorMessage("Pessoa Juridica da Entidade não identificada");
      pushToBase(navigate);
    } else {
      setPessoaJuridicaEfpc(pjReq);
    }
  }

  function pushToManter(efpc: IEfpc) {  // ABRE A TELA DE DETALHES DO DIRETOR
    let tpSelecao = {
      manter: 2,
      data: efpc
    }
    navigate("/" + import.meta.env.VITE_APP_BASE + "/efpc-manter", { state: tpSelecao });
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const validarEfpc = () => {
    if (!pessoaJuridicaEfpc || !pessoaJuridicaEfpc.numero || pessoaJuridicaEfpc.numero === "") {
      errorMessage("Não foi possível identificar a Pessoa Jurídica para vincular à Entidade.");
      return;
    }

    // if (!currentForm.efpcNumeroProcesso || currentForm.efpcNumeroProcesso === "") {
    //   errorMessage("Número do processo da EFPC não pode ficar vazio.");
    //   return;
    // }

    form
      .validateFields()
      .then(() => {
        sendForm();
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });

  };

  const sendForm = async () => {
    const currentForm = form.getFieldsValue();

    setTipLoading("Salvando dados ...");
    setLoading(true);

    const json: IEfpc =
    {
      numero: "",
      serie: undefined,
      sigla: currentForm.sigla,
      quantidadeDiretores: currentForm.quantidadeDiretores,
      quantidadeConselheiroFiscal: currentForm.quantidadeConselheiroFiscal,
      quantidadeConselhoDeliberativo: currentForm.quantidadeConselhoDeliberativo,
      fundamentacaoLegal: fundamentacaoLegal,
      tipo: 1,
      dataVigencia: currentForm.dataAprovacaoAutorizacao ? dayjs(currentForm.dataAprovacaoAutorizacao).format("YYYY-MM-DD") : "",
      observacoes: currentForm.observacoes,
      numeroPessoaJuridica: pessoaJuridicaEfpc ? pessoaJuridicaEfpc.numero : "",
      documentos: [
        ...(efpcDocumento ?? []),
        ...(efpcDocumentoOutros ?? []),
        ...(efpcDocumentoAnalise ?? [])
      ].map((e: IDocumento) => ({ ...e })),
    }

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = `/efpc/autorizacao/aprovar/${operacaoAutorizarEfpc?.numero}`;

      await apiPrimarias.post(query, json).then((response) => {
        //console.log(response);
        successMessage(
          `Entidade ${response.data.sigla} (${maskNuMatricula(response.data.numero)}) cadastrado com Sucesso`
        );
        setEfpcRetPosCadastro(response.data);
      })
    } catch (error: any) {
      let data: IErroApi = error.response.data;
      let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
      let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
      setEstadoErroApi(error.response.status);
      setMsgErroApi(msgErro + msgDetalheErro);
      if (error.response.status < 500) {
        setErroApi(data);
      } else {
        if (error.response.status === 503)
          errorMessage("Servidor remoto não disponível");
        else
          errorMessage(msgErro);
      }
    } finally {
      setLoading(false);
    }

  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    form.setFieldsValue({
      idEfpc: undefined,
      idPessoaJuridica: undefined,
      dtInicioAtuacao: undefined,
      dtFimAtuacao: undefined,
      campoServidorPublico: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const carregaListaDocumentosEstatutoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("1126999420597250").then((response) => {
      setCtrlDocsEfpcDocumento(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
      setListDocumentosEstatuto(listaLocal);
    });
  }

  const carregaListaDocumentosOutrosEfpcOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("2252899327439874").then((response) => {
      setCtrlDocsEfpcDocumentoOutros(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosOutrosEfpc(listaLocal);
  }

  const carregaListaDocumentosAnaliseOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("4504699141125121").then((response) => {
      setCtrlDocsEfpcDocumentoAnalise(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosAnalise(listaLocal);
  }


  const carregaListaFundamentacaoLegalOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaFundamentacaoLegal().then((response) => {
      response.data.forEach((p: IFundamentacaoLegal) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListFundamentacaoLegal(listaLocal);
  }

  const handleFundamentacaoLegal = async (fundamentacaoLegal: any) => {
    form.setFieldsValue({
      nmFundamentacaoLegal: fundamentacaoLegal.label,
    });
    setFundamentacaoLegal(fundamentacaoLegal.value);
  };

  return (
    <>
      {/* <Prompt
        when={idEfpc !== undefined && idEfpc !== 0}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>

        <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >

          <div className="main-content pl-sm-3 mt-4">
            <h1>Cadastrar Entidade</h1>
          </div>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações da Operação de Autorização da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} xl={2}>
              <Form.Item label="Número"
                name="operacaoNumero">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item
                label="CNPJ do Requerente"
                name="operacaoCnpjRequerente">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Data da Posicao"
                name="operacaoDtPosicao">
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabled={true}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={10}>
              <Form.Item label="Razão Social"
                name="operacaoRazaoSocial">
                <Input disabled={true} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={12}>
              <Form.Item label="Justificativa"
                name="operacaoJustificativa">
                <Input disabled={true} />
              </Form.Item>
            </Col>
          </Row>


          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Básicas da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} xl={5} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 2}>
              <Form.Item
                label="CNPJ da Entidade"
                name="efpcNumeroEfpcCnpj">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>


            <Col xs={24} xl={7} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 3}>
              <Form.Item
                label="Identificador Provisório (Processo)"
                name="efpcNumeroEfpcProcesso">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="#####.######/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 2}>
              <Form.Item
                label="Número do processo"
                name="efpcNumeroProcesso">
                <PatternFormat
                  customInput={Input}
                  format="#####.######/####-##"
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={10}>
              <Form.Item label="Razão Social"
                name="efpcRazaoSocial">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4} >
              <Form.Item style={{ alignItems: 'center' }}
                label={mostrarDetalhesPessoaJuridica ? "Ocultar detalhe Cadastro de Pessoa Jurídica" : "Detalhar Cadastro de Pessoa Jurídica"}
              >
                <Button
                  shape='round'
                  onClick={() => {
                    setMostrarDetalhesPessoaJuridica(!mostrarDetalhesPessoaJuridica);
                  }}
                  type='primary'
                  icon={<UserOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Perfil da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Sigla"
                name="sigla"
                rules={[
                  {
                    required: true,
                    message: "Sigla obrigatória não preenchida",
                  },
                ]}
              >
                <Input

                  onChange={(e) => {
                    setSigla(e.target.value)
                    form.setFieldsValue({
                      sigla: e.target.value.toUpperCase(),
                    })
                  }}
                  placeholder="Digitar Sigla" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Fundamentação Legal"
                name="nmFundamentacaoLegal"
                rules={[
                  {
                    required: true,
                    message: "Fundamentação Legal obrigatório não preenchido",
                  },
                ]}
              >
                <Select
                  showSearch filterOption optionFilterProp='children'
                  placeholder='SELECIONE UMA FUNDAMENTAÇÃO LEGAL'
                  options={listFundamentacaoLegal}
                  onChange={(_, index) => {
                    handleFundamentacaoLegal(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item
                label="Qtd. Máx Diretores Executivos"
                name="quantidadeDiretores"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de diretores Executivos obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de diretores Executivos"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Qtd. Máx Conselheiros Fiscais"
                name="quantidadeConselheiroFiscal"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de Conselheiros Fiscais obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de Conselheiros Fiscais"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Qtd. Máx Conselheiros Deliberativos"
                name="quantidadeConselhoDeliberativo"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de Conselheiros Deliberativos obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de Conselheiros Deliberativos"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={12}>
              <Form.Item
                label="Situação"
                name="nmSituacao">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data da Situação"
                name="dataSituacao">
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabled={true}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data da Autorização"
                name="dataAprovacaoAutorizacao"
                rules={[
                  {
                    required: true,
                    message: "Data da Autorização obrigatório não preenchido",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ display: mostrarDetalhesPessoaJuridica ? 'inline' : 'none' }} >
            {/* <>
              <PessoaJuridicaDadosComplementares
                form={form}
                idPessoaFisica={state.idPessoaFisica}
                mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaJuridica}
              />
            </> */}
          </Row>
        </Form>

        <Tabs>
          <Tabs.TabPane tab="Estatuto" key="item-1">
            <FormModalDocumento
              ctrlDoc={ctrlDocsEfpcDocumento}
              objetoDocumento={efpcDocumento}
              setObjetoDocumento={setEfpcDocumento}
              listaDocumentos={listDocumentosEstatuto}
              manter={manter}
            />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Outros Documentos da Entidade" key="item-2">
            <FormModalDocumento
              ctrlDoc={ctrlDocsEfpcDocumentoOutros}
              objetoDocumento={efpcDocumentoOutros}
              setObjetoDocumento={setEfpcDocumentoOutros}
              listaDocumentos={listDocumentosOutrosEfpc}
              manter={manter}
            />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Documentação de Análise/Autorização" key="item-3">
            <FormModalDocumento
              ctrlDoc={ctrlDocsEfpcDocumentoAnalise}
              objetoDocumento={efpcDocumentoAnalise}
              setObjetoDocumento={setEfpcDocumentoAnalise}
              listaDocumentos={listDocumentosAnalise}
              manter={manter}
            />
          </Tabs.TabPane>

        </Tabs>

        <Form layout='vertical' style={{ padding: 24 }} onFinish={validarEfpc} onFinishFailed={onFinishFailed} scrollToFirstError form={form} >

          <CadInfoBotoes
            resetForm={resetForm}
            detalhar={false}
            form={form}
            resetColor={resetColor}
            manter={1}
            msgConfirmacao={`Nova Entidade: ${sigla}`}
            rotaConsultar={"/" + import.meta.env.VITE_APP_BASE}
          />

        </Form >
      </Spin >

    </>
  );
};

export default Cadastrar;